import { AppContextType } from '@1js/acui-context';
import { checkExperiment, ribbonExperiments } from '@1js/acui-experiments';
import { MenuDefinition } from '@1js/acui-menu';

function shouldCacheBecauseColorPickerInMenu(menuDefinition: MenuDefinition | undefined) {
  const sections = menuDefinition?.sections;
  if (sections) {
    return sections.some(section => section.controls.some(control => control.type === 'AppColorPickerProps'));
  }

  return false;
}

function shouldCacheBecauseGalleryInMenu(menuDefinition: MenuDefinition | undefined) {
  const sections = menuDefinition?.sections;
  if (sections) {
    return sections.some(section =>
      section.controls.some(
        control => control.hasOwnProperty('galleryButtons') || control.hasOwnProperty('gallerySections')
      )
    );
  }

  return false;
}

/**
 * Returns whether the current menu should be persisted.
 *
 * Note if menus are connected to the store we will always persist menus because we cannot see what the menus
 * contains as the props will only be generated when the menu is opened.
 */
export function shouldPersistMenu(context: AppContextType, menuDefinition: MenuDefinition | undefined) {
  return (
    checkExperiment(context, ribbonExperiments.areMenusConnectedToStore) ||
    checkExperiment(context, ribbonExperiments.areMenusConnectedToStoreFG) ||
    shouldCacheBecauseColorPickerInMenu(menuDefinition) ||
    shouldCacheBecauseGalleryInMenu(menuDefinition)
  );
}
